export enum AlertLogStatus {
  TODO = 'TODO',
  DONE = 'DONE',
}

export enum AlertLogStatusEnum {
  DONE = 'Traitées',
  TODO = 'A traiter',
}

export enum AlertLogLevel {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  INFO = 'INFO',
}

export const AlertLogLevelTranslation: { [key: string]: string } = {
  [AlertLogLevel.ERROR]: 'Erreur',
  [AlertLogLevel.WARNING]: 'Avertissement',
  [AlertLogLevel.INFO]: 'Information',
};

export const getAlertLogLevel = (level: string): string => {
  return AlertLogLevelTranslation[level] || 'Information';
};
